import { createPolygon } from "../../createPolygon";
import { isMouseOnVerticies } from "../mouseOnVerticies";

export function setup(
  visualisation,
  drawingLibrary,
  containerElement,
  framerate,
  onPolygonsChange,
  onCurrentPolygonChange
) {
  // #REF
  let cnv = drawingLibrary.createCanvas(
    containerElement.offsetWidth,
    containerElement.offsetHeight
  );
  // onCanvasChange(drawingLibrary);

  visualisation.setScale(1);

  drawingLibrary._canvas = cnv;
  visualisation.setPixelCenter({
    x: drawingLibrary.width / 2,
    y: drawingLibrary.height / 2,
  });
  visualisation.setXOffset(0);
  visualisation.setYOffset(0);

  drawingLibrary.frameRate(framerate);
  drawingLibrary.angleMode(drawingLibrary.DEGREES);
  drawingLibrary.imageMode(drawingLibrary.CENTER);

  // add event listeners for mouse and touch
  drawingLibrary.mouseClicked = () => {};

  // on mouse release stop dragging vertex
  drawingLibrary.mouseReleased = (event) => {
    if (event.target !== drawingLibrary._canvas.elt) {
      return;
    }
    // lastDraggedVertex = draggingVertex;
    visualisation.setDraggingVertex(null);

    visualisation.selectPlant(null);
    // draggingVertex = null;
  };

  drawingLibrary.mousePressed = (event) => {
    // if the event target is the canvas then continue
    if (event.target !== drawingLibrary._canvas.elt) {
      return;
    }

    let foundSelectedVertex = false;
    if (visualisation.isEditMode()) {
      // check if mouse is over a vertex
      console.log("is edit mode");

      // check selected polygon first
      if (
        visualisation.selectedPolygon() &&
        !visualisation.selectedPolygon().locked()
      ) {
        console.log("Checking selected polygon when not locked");
        let polygon = visualisation.selectedPolygon().verticies();

        let index = isMouseOnVerticies(visualisation, drawingLibrary, polygon);
        console.log("index", index);
        if (index !== -1) {
          // start dragging vertex
          visualisation.setDraggingVertex({
            polygonIndex: visualisation

              .polygons()
              .findIndex(
                (polygon) => polygon === visualisation.selectedPolygon()
              ),
            vertexIndex: index,
          });
          foundSelectedVertex = true;
          console.log("foundSelectedVertex");
          // break;
        }
      }
      console.log("not foundSelectedVertex");
      if (!foundSelectedVertex) {
        // check all polygons

        for (let i = 0; i < visualisation.polygons().length; i++) {
          let poly = visualisation.polygons()[i];

          // if polgon is locked then dont check
          if (visualisation.currentPolygon().length > 0) {
            continue;
          }
          let polygon = poly.verticies();

          for (let j = 0; j < polygon.length; j++) {
            let vertex = polygon[j];
            let distance = drawingLibrary.dist(
              visualisation.mouseX(),
              visualisation.mouseY(),
              vertex.x,
              vertex.y
            );
            if (distance < 10) {
              console.log("distance < 50");

              // isnt selected so select it

              // selectedPolygon = visualisation.polygons()[i];
              // deselect current selected
              if (visualisation.selectedPolygon()) {
                visualisation.selectedPolygon().deselect();
              }
              visualisation.polygons()[i].select();

              onPolygonsChange(visualisation.polygons());
              foundSelectedVertex = true;
              break;
            }
          }
          console.log("not other vertex");

          // if not selected then skip
          if (poly.selected() && !visualisation.selectedPolygon().locked()) {
            // if click between vertices then add new vertex
            if (!foundSelectedVertex) {
              for (let j = 0; j < polygon.length; j++) {
                let vertex1;
                let vertex2;
                if (j === polygon.length - 1) {
                  // if last vertex then check between last and first vertex
                  vertex1 = polygon[j];
                  vertex2 = polygon[0];
                } else {
                  vertex1 = polygon[j];
                  vertex2 = polygon[j + 1];
                }
                let distance = drawingLibrary.dist(
                  visualisation.mouseX(),
                  visualisation.mouseY(),
                  vertex1.x,
                  vertex1.y
                );
                let distance2 = drawingLibrary.dist(
                  visualisation.mouseX(),
                  visualisation.mouseY(),
                  vertex2.x,
                  vertex2.y
                );
                let distance3 = drawingLibrary.dist(
                  vertex1.x,
                  vertex1.y,
                  vertex2.x,
                  vertex2.y
                );
                if (distance + distance2 - distance3 < 10) {
                  // add vertex between vertex1 and vertex2
                  polygon.splice(j + 1, 0, {
                    x: visualisation.mouseX(),
                    y: visualisation.mouseY(),
                  });
                  foundSelectedVertex = true;

                  // start dragging vertex
                  visualisation.setDraggingVertex({
                    polygonIndex: i,
                    vertexIndex: j + 1,
                  });
                  break;
                }
              }
            }
          }

          if (visualisation.draggingVertex() !== null) {
            break;
          }
        }
      }

      // check if mouse over center of polygon
      console.log("Checking if over  center of polygon");
      if (!foundSelectedVertex) {
        for (let i = 0; i < visualisation.polygons().length; i++) {
          let poly = visualisation.polygons()[i];
          if (visualisation.currentPolygon().length > 0) {
            continue;
          }
          let polygon = poly.verticies();
          // find the center of the polygon
          let polygonCenter = { x: 0, y: 0 };
          for (let j = 0; j < polygon.length; j++) {
            polygonCenter.x += polygon[j].x;
            polygonCenter.y += polygon[j].y;
          }
          polygonCenter.x /= polygon.length;
          polygonCenter.y /= polygon.length;

          let distance = drawingLibrary.dist(
            visualisation.mouseX(),
            visualisation.mouseY(),
            polygonCenter.x,
            polygonCenter.y
          );
          console.log("distance", distance);
          if (distance < 10) {
            // select polygon

            if (visualisation.selectedPolygon()) {
              visualisation.selectedPolygon().deselect();
            }
            poly.select();
            onPolygonsChange(visualisation.polygons());
            foundSelectedVertex = true;
            break;
          }
        }
      }

      // if no selected vertex check if click plant
      if (!foundSelectedVertex) {
        console.log();
        let selectedPolygon = visualisation.selectedPolygon();
        if (selectedPolygon) {
          let plants = selectedPolygon.plants();
          if (plants) {
            for (let i = 0; i < plants.length; i++) {
              let plant = plants[i];
              let distance = drawingLibrary.dist(
                visualisation.mouseX(),
                visualisation.mouseY(),
                plant.x,
                plant.y
              );
              console.log(distance);
              if (distance < 10) {
                console.log("found plant");
                // select plant
                visualisation.selectPlant(plant);
                foundSelectedVertex = true;
                break;
              }
            }
          }
        }
      }

      if (!foundSelectedVertex) {
        if (visualisation.selectedPolygon()) {
          visualisation.selectedPolygon().deselect();
          console.log("deselect");
        }
        visualisation.selectPlant(null);
        visualisation.setDraggingVertex(null);
        // lastDraggedVertex = draggingVertex;
        // draggingVertex = null;
        onPolygonsChange(visualisation.polygons());
      }
    } else if (visualisation.isCreateMode()) {
      // check the current polygon
      if (!foundSelectedVertex) {
        console.log("currentPolygon");
        for (let j = 0; j < visualisation.currentPolygon().length; j++) {
          let vertex = visualisation.currentPolygon()[j];
          let distance = drawingLibrary.dist(
            visualisation.mouseX(),
            visualisation.mouseY(),
            vertex.x,
            vertex.y
          );
          if (distance < 10) {
            // start dragging vertex
            visualisation.setDraggingVertex({
              polygonIndex: -1,
              vertexIndex: j,
            });
            foundSelectedVertex = true;
            console.log("foundSelectedVertex");
            break;
          }
        }
      }

      if (!foundSelectedVertex) {
        console.log("add vertex");

        // Check if mouse is close to another polygon vertex and snap to it
        let snapDistance = 10;
        let snapVertex = null;

        for (let i = 0; i < visualisation.polygons().length; i++) {
          let poly = visualisation.polygons()[i];

          // not the current polygon
          if (
            visualisation.draggingVertex() &&
            i === visualisation.draggingVertex().polygonIndex
          ) {
            continue;
          }
          let polygon = poly.verticies();
          for (let j = 0; j < polygon.length; j++) {
            let vertex = polygon[j];
            let distance = drawingLibrary.dist(
              visualisation.mouseX(),
              visualisation.mouseY(),
              vertex.x,
              vertex.y
            );
            if (distance < snapDistance) {
              snapVertex = vertex;
              break;
            }
          }
          if (snapVertex !== null) {
            break;
          }
        }
        if (snapVertex !== null) {
          // snap vertex to snapVertex
          visualisation.currentPolygon().push({
            x: snapVertex.x,
            y: snapVertex.y,
          });
        } else {
          // add vertex to current polygon
          visualisation.currentPolygon().push({
            x: visualisation.mouseX(),
            y: visualisation.mouseY(),
          });
        }

        onCurrentPolygonChange(visualisation.currentPolygon());
        visualisation.setDraggingVertex(null);
        onPolygonsChange(visualisation.polygons());
      }
    } else if (visualisation.isCreateLineMode()) {
      // check if mouse is over a vertex
      //    current line
      //    other lines
      // otherwise add new vertex to current line
    }
  };

  drawingLibrary.mouseMoved = (event) => {
    if (event.target !== drawingLibrary._canvas.elt) {
      return;
    }
    if (visualisation.isViewMode()) {
      return;
    }
    if (visualisation.selectedPlant()) {
      // if dragging plant then update position
      visualisation.selectedPlant().x = visualisation.mouseX();
      visualisation.selectedPlant().y = visualisation.mouseY();
      return;
    } else if (visualisation.draggingVertex() !== null) {
      // if locked then dont update
      // if (lockedPolygons.includes(draggingVertex.polygonIndex)) {
      //   return;
      // }
      if (
        visualisation.draggingVertex().polygonIndex != -1 &&
        visualisation
          .polygons()
          [visualisation.draggingVertex().polygonIndex].locked()
      ) {
        return;
      }
      if (visualisation.draggingVertex().polygonIndex === -1) {
        // drag current polygon vertex
        visualisation.currentPolygon()[
          visualisation.draggingVertex().vertexIndex
        ].x = visualisation.mouseX();
        visualisation.currentPolygon()[
          visualisation.draggingVertex().vertexIndex
        ].y = visualisation.mouseY();
      } else {
        // update position of dragging vertex
        let polygon = visualisation
          .polygons()
          [visualisation.draggingVertex().polygonIndex].verticies();
        let vertex = polygon[visualisation.draggingVertex().vertexIndex];
        if (!visualisation.snapVertex) {
          vertex.x = visualisation.mouseX();
          vertex.y = visualisation.mouseY();
        }
        // if oldX and oldY are null then set them
        if (visualisation.oldX === null || visualisation.oldX === undefined) {
          visualisation.oldX = visualisation.mouseX();
          visualisation.oldY = visualisation.mouseY();
        }

        // if has changed by more than 10 pixels then update
        if (
          drawingLibrary.dist(
            visualisation.oldX,
            visualisation.oldY,
            visualisation.mouseX(),
            visualisation.mouseY()
          ) > 20
        ) {
          // onPolygonsChange(visualisation.polygons());
          visualisation.oldX = visualisation.mouseX();
          visualisation.oldY = visualisation.mouseY();

          // Check if vertex is close to  another vertex of another polygon and snap to it
          let snapDistance = 10;
          let snapVertex = null;

          visualisation.snapVertex = null;

          // check all polygons
          for (let i = 0; i < visualisation.polygons().length; i++) {
            let poly = visualisation.polygons()[i];
            // if polgon is locked then dont check
            if (poly.locked()) {
              continue;
            }
            // not the current polygon
            if (i === visualisation.draggingVertex().polygonIndex) {
              continue;
            }
            let polygon = poly.verticies();
            for (let j = 0; j < polygon.length; j++) {
              let vertex = polygon[j];
              let distance = drawingLibrary.dist(
                visualisation.mouseX(),
                visualisation.mouseY(),
                vertex.x,
                vertex.y
              );
              if (distance < snapDistance) {
                snapVertex = vertex;
                break;
              }
            }
            if (snapVertex !== null) {
              break;
            }
          }
          if (snapVertex !== null) {
            // snap vertex to snapVertex
            vertex.x = snapVertex.x;
            vertex.y = snapVertex.y;
            visualisation.snapVertex = snapVertex;
          }
        }
      }
    }
  };

  drawingLibrary.touchMoved = (event) => {
    if (event.target !== drawingLibrary._canvas.elt) {
      return;
    }
    drawingLibrary.mouseMoved(event);
  };
}
